export default __webpack_public_path__ + "static/media/css.9a088dd1.png";